import Http from '@/api/http.js'

export default {
  index(type){
    return Http.get(`/payment_${type}`);
  },
  create(payMode, type){
    if (type == 'options'){
      return Http.post(`/payment_${type}`, {
        payment_option: {
          description: payMode.description,
          costBase: payMode.costBase,
          display_name: payMode.display_name
        }
      });
    } else if (type == 'times'){
      return Http.post(`/payment_${type}`, {
        payment_time: {
          description: payMode.description,
          costBase: payMode.costBase,
          daysBase: payMode.daysBase,
          timesBase: payMode.timesBase,
          entrance: payMode.entrance,
          offset: payMode.offset

        }
      });
    }
  },
  update(payMode, type) {
    if (type == 'options'){
      return Http.put(`/payment_${type}/${payMode.id}`, {
        payment_option: {
          id: payMode.id,
          display_name: payMode.attributes.display_name,
          costBase: payMode.attributes.costBase,
        }
      });
    } else if (type == 'times'){
      return Http.put(`/payment_${type}/${payMode.id}`, {
        payment_time: {
          id: payMode.id,
          description: payMode.attributes.description,
          costBase: payMode.attributes.costBase,
          daysBase: payMode.attributes.daysBase,
          timesBase: payMode.attributes.timesBase,
          entrance: payMode.attributes.entrance,
          offset: payMode.attributes.offset
        }
      });
    }
  },
  updateInfo(updatePayment, id) {
    return Http.put(`/payment_${type}/${id}`, {
      payment: {
        id: id,
        'user_attributes':      updatePayment.user_attributes,
      }
    });
  },
  show(payMode_id, type){
    return Http.get(`payment_${type}/${payMode_id}`);
  },
}